import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72a31baf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "special-note-input-container px-2 mb-2" }
const _hoisted_2 = { class: "flex p-1 align-items-center" }
const _hoisted_3 = { class: "circle-index" }
const _hoisted_4 = { class: "pl-1 text-sm-italic flex" }
const _hoisted_5 = {
  class: "text-center",
  style: {"width":"1rem"}
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-orange text-sm font-italic" }

import { get, set, useDateFormat } from "@vueuse/core";
import { ref, watch } from "vue";
import { ISpecialNote } from "@/clinic/typings";
import { DATE_TIME_FORMAT } from "@/clinic/typings/constants/booking";

export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialNoteInput',
  props: {
    note: null,
    index: null,
    savedStatus: { type: Boolean },
    editable: { type: Boolean }
  },
  emits: ["onInput", "toggleSavedStatus"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  note: ISpecialNote;
  index: number;
  savedStatus: boolean;
  editable: boolean;
};





const data = ref<ISpecialNote>(props.note);
const tempContent = ref(props.note.content || "");
const showNotChangedText = ref<boolean>(false);
const showAsterisk = ref(props.note.id == undefined);
const editable = ref(props.editable);

const handleInput = () => {
  if (get(tempContent) != "") {
    set(showAsterisk, get(data).content != get(tempContent));
  }
  if (get(data).id) {
    get(data)._destroy = get(data).content == "" ? true : undefined;
  }
};

watch(
  () => props.savedStatus,
  newSavedStatus => {
    if (newSavedStatus) {
      set(showAsterisk, !props.note.id);
      set(tempContent, props.note.content);
      set(data, props.note);
      emits("toggleSavedStatus");
    }
  }
);
watch(
  () => props.editable,
  newEditable => set(editable, newEditable)
);
watch(
  () => props.note,
  newNote => {
    set(showAsterisk, !newNote.id);
    set(data, newNote);
    set(tempContent, newNote);
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.index + 1), 1),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(get)(_unref(useDateFormat)(props.note.updated_at, _unref(DATE_TIME_FORMAT)))) + " ", 1),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(" * ")
        ])), [
          [_vShow, showAsterisk.value],
          [_directive_tooltip, !props.note.id ? '追加' : 'かわった']
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("textarea", {
      class: "note w-full p-2",
      placeholder: "特記事項を追加できます。",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.content) = $event)),
      disabled: !editable.value,
      onInput: handleInput
    }, null, 40, _hoisted_6), [
      [_vModelText, data.value.content]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, "保存する前に何かを変更してください。", 512), [
      [_vShow, showNotChangedText.value]
    ])
  ]))
}
}

})